import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/usr/local/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/app.min.js",
    "revision": "12f5978a15b7c9d4681cddb3a735c775"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "37f49371370b4257da6304120b789831"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "4e7448cd52e7be7804236973ff1c37b0"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "2a45abd06dfe78e69135e9f87f9b78d3"
  },
  {
    "url": "js/math-print.js",
    "revision": "9d98c920695f6c3395da4b68f723e60a"
  },
  {
    "url": "index.html",
    "revision": "6d4fee0a8111a8faf43063d25ceea2dc"
  },
  {
    "url": "open.html",
    "revision": "d71816b3b00e769fc6019fcdd6921662"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "b83ab40a56fdf706d7e633e7c30db289"
  },
  {
    "url": "styles/atlas.css",
    "revision": "e8152cda9233d3a3af017422993abfce"
  },
  {
    "url": "styles/dark.css",
    "revision": "87d5d01385c5d0f0c4c4f5d0f3532826"
  },
  {
    "url": "js/croppie/croppie.min.css",
    "revision": "fc297c9002c79c15a132f13ee3ec427e"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "d82b9c14d7a069efabef719a8a5f3975"
  },
  {
    "url": "js/viewer-static.min.js",
    "revision": "6e77754256acbd84030bd3d8072baee3"
  },
  {
    "url": "connect/jira/editor-1-3-3.html",
    "revision": "fb7e91ab8890425d55f0122a01cc5b20"
  },
  {
    "url": "connect/jira/viewerPanel-1-3-12.html",
    "revision": "adad95619154b88fda78e125d87d9f73"
  },
  {
    "url": "connect/jira/fullScreenViewer-1-3-3.html",
    "revision": "c58a7c55a335f49d84bc4b1aac9885aa"
  },
  {
    "url": "connect/jira/viewerPanel.js",
    "revision": "54905a6953a0e3890491d93eaa3512ca"
  },
  {
    "url": "connect/jira/spinner.gif",
    "revision": "7d857ab9d86123e93d74d48e958fe743"
  },
  {
    "url": "connect/jira/editor.js",
    "revision": "435d01373a459c134b05b6640c88c327"
  },
  {
    "url": "connect/jira/fullscreen-viewer-init.js",
    "revision": "197ed5837ed27992688fc424699a9a78"
  },
  {
    "url": "connect/jira/fullscreen-viewer.js",
    "revision": "0e8e4adf7a140480887e4a98581f5c19"
  },
  {
    "url": "plugins/connectJira.js",
    "revision": "4cefa13414e0d406550f3c073923080c"
  },
  {
    "url": "plugins/cConf-comments.js",
    "revision": "c787357209cff2986dcca567b599e2ef"
  },
  {
    "url": "plugins/cConf-1-4-8.js",
    "revision": "159835ebab73810cc3f4fea9d904fab6"
  },
  {
    "url": "connect/confluence/connectUtils-1-4-8.js",
    "revision": "6f5ae4db2e883486f80f9f88d8c6f88b"
  },
  {
    "url": "connect/new_common/cac.js",
    "revision": "b1eb16ac1824f26824c748e8b8028e30"
  },
  {
    "url": "connect/gdrive_common/gac.js",
    "revision": "38f1df3ecc4d78290493f47e62202138"
  },
  {
    "url": "connect/onedrive_common/ac.js",
    "revision": "293aa21acaf0a3349686f420b2be874a"
  },
  {
    "url": "connect/confluence/viewer-init.js",
    "revision": "4a60c6c805cab7bc782f1e52f7818d9f"
  },
  {
    "url": "connect/confluence/viewer.js",
    "revision": "1671acc2d56cee6887091020c07158e7"
  },
  {
    "url": "connect/confluence/viewer-1-4-42.html",
    "revision": "c154ee66bab65cd0e476c1d64c64cb8d"
  },
  {
    "url": "connect/confluence/macroEditor-1-4-8.html",
    "revision": "689fa63fd3a384662b4199f6e4a5b5c1"
  },
  {
    "url": "connect/confluence/includeDiagram-1-4-8.js",
    "revision": "f1be180a9536435e73d0e57cfc52fe63"
  },
  {
    "url": "connect/confluence/includeDiagram.html",
    "revision": "b4ec3c4afe5a24a14bf2a6673ab0f19f"
  },
  {
    "url": "connect/confluence/macro-editor.js",
    "revision": "29d2a5232e54f015f05c43d2a14b8de1"
  },
  {
    "url": "math/MathJax.js",
    "revision": "b2c103388b71bb3d11cbf9aa45fe9b68"
  },
  {
    "url": "math/config/TeX-MML-AM_SVG-full.js",
    "revision": "d5cb8ac04050983170ae4af145bc66ff"
  },
  {
    "url": "math/jax/output/SVG/fonts/TeX/fontdata.js",
    "revision": "495e5a410955d1b6178870e605890ede"
  },
  {
    "url": "math/jax/element/mml/optable/BasicLatin.js",
    "revision": "cac9b2e71382e62270baa55fab07cc13"
  },
  {
    "url": "math/jax/output/SVG/fonts/TeX/Size2/Regular/Main.js",
    "revision": "e3e5e4d5924beed29f0844550b5c8f46"
  },
  {
    "url": "math/jax/output/SVG/fonts/TeX/Main/Regular/LetterlikeSymbols.js",
    "revision": "0767cbad7275b53da128e7e5e1109f7c"
  },
  {
    "url": "math/jax/output/SVG/fonts/TeX/Main/Regular/GreekAndCoptic.js",
    "revision": "346302a5c5ee00e01c302148c56dbfe3"
  },
  {
    "url": "resources/dia.txt",
    "revision": "24f788f45cddb53015d921cd7faca80f"
  },
  {
    "url": "resources/dia_am.txt",
    "revision": "0a457f654643e72970de7a3efea4fe7f"
  },
  {
    "url": "resources/dia_ar.txt",
    "revision": "c142d4624a3f4eee10d5f8c61c95ca85"
  },
  {
    "url": "resources/dia_bg.txt",
    "revision": "79bb067a55fdd176fd3cce84140984de"
  },
  {
    "url": "resources/dia_bn.txt",
    "revision": "adbf0204fe2a846bedbe3546ab202f93"
  },
  {
    "url": "resources/dia_bs.txt",
    "revision": "fa543af5f0a17819881be5d179e9ffa0"
  },
  {
    "url": "resources/dia_ca.txt",
    "revision": "95a96cb0f0d60dc3849f4101c1c39929"
  },
  {
    "url": "resources/dia_cs.txt",
    "revision": "62a18aaa139129d6a7f7a9c770bf93ae"
  },
  {
    "url": "resources/dia_da.txt",
    "revision": "92766d771b91e461230cac9273f053c8"
  },
  {
    "url": "resources/dia_de.txt",
    "revision": "34c5f98ba7d5ec127623779ebcfd1314"
  },
  {
    "url": "resources/dia_el.txt",
    "revision": "cc976d4542574cc0e98293a30ef1ef7f"
  },
  {
    "url": "resources/dia_eo.txt",
    "revision": "33140115a3fbb3a960d720fdff669ff3"
  },
  {
    "url": "resources/dia_es.txt",
    "revision": "206821ef4dc5410506a4a7c3a06a080d"
  },
  {
    "url": "resources/dia_et.txt",
    "revision": "932f4326004c94f76dff242436a111d5"
  },
  {
    "url": "resources/dia_eu.txt",
    "revision": "cba013e353edf81d8afbd258efab990a"
  },
  {
    "url": "resources/dia_fa.txt",
    "revision": "6f4b87c50a91e7fcb8adf3a77b017ce6"
  },
  {
    "url": "resources/dia_fi.txt",
    "revision": "b72df0e80a6298b9cb469cd5da7d246d"
  },
  {
    "url": "resources/dia_fil.txt",
    "revision": "057a752c3cb5151afa0952581601d19f"
  },
  {
    "url": "resources/dia_fr.txt",
    "revision": "3ed43d38952aa653e3bb2f2a8c3c7b95"
  },
  {
    "url": "resources/dia_gl.txt",
    "revision": "8cef66a5ca45c5ff2ad35cdc60b1a25c"
  },
  {
    "url": "resources/dia_gu.txt",
    "revision": "b91c080769b4f0a20af8d591d06c21c8"
  },
  {
    "url": "resources/dia_he.txt",
    "revision": "30aba78664e0bfe36f114d30697497ea"
  },
  {
    "url": "resources/dia_hi.txt",
    "revision": "b1fa6c156f54c0ab5b0aec7991e20e09"
  },
  {
    "url": "resources/dia_hr.txt",
    "revision": "184dd98363259da0da4db96166e6507d"
  },
  {
    "url": "resources/dia_hu.txt",
    "revision": "43d89a61e4e932a0b67976449aeb4f0a"
  },
  {
    "url": "resources/dia_id.txt",
    "revision": "7b8a5b76adba60e1ce816a73cd0622be"
  },
  {
    "url": "resources/dia_it.txt",
    "revision": "9f6c7953b8085f303331c6582459b6c3"
  },
  {
    "url": "resources/dia_ja.txt",
    "revision": "36ee9365262071cd01ebb69f073fac41"
  },
  {
    "url": "resources/dia_kn.txt",
    "revision": "9dc29693a45d7b850de16b5edbaaaefd"
  },
  {
    "url": "resources/dia_ko.txt",
    "revision": "4eae07e06aee0525919a1a3314d728fb"
  },
  {
    "url": "resources/dia_lt.txt",
    "revision": "5104bcfbbceecc6d2ad2b1c7df8bd121"
  },
  {
    "url": "resources/dia_lv.txt",
    "revision": "7fdcc0d72c8d41d9d1da002424eb426e"
  },
  {
    "url": "resources/dia_ml.txt",
    "revision": "43e179ab5a820fffe0f207b2f3109d06"
  },
  {
    "url": "resources/dia_mr.txt",
    "revision": "2c3e0858f846821600e2518de3c3b0c4"
  },
  {
    "url": "resources/dia_ms.txt",
    "revision": "7d0c4f4196d531eb47dd0fd3bb7bd1c7"
  },
  {
    "url": "resources/dia_my.txt",
    "revision": "24f788f45cddb53015d921cd7faca80f"
  },
  {
    "url": "resources/dia_nl.txt",
    "revision": "fa9ffd74dfd3b413ea9d2d7bdeb6b14c"
  },
  {
    "url": "resources/dia_no.txt",
    "revision": "c3c8666b6b9416968511750b7d3400ef"
  },
  {
    "url": "resources/dia_pl.txt",
    "revision": "2877a4a447b4059934150ca30fc05e03"
  },
  {
    "url": "resources/dia_pt-br.txt",
    "revision": "1ca41b4ff3e5eb71279ba5da084e93a9"
  },
  {
    "url": "resources/dia_pt.txt",
    "revision": "416613a63155e2f5e07cc41b08b8e9c1"
  },
  {
    "url": "resources/dia_ro.txt",
    "revision": "46c800ac3c5e5a8fd0d9be67f57ff906"
  },
  {
    "url": "resources/dia_ru.txt",
    "revision": "cf082580db1cc962ae0e10076518ee11"
  },
  {
    "url": "resources/dia_si.txt",
    "revision": "24f788f45cddb53015d921cd7faca80f"
  },
  {
    "url": "resources/dia_sk.txt",
    "revision": "0a4b6ef5dc1227e81e54e2d9dff4fbc7"
  },
  {
    "url": "resources/dia_sl.txt",
    "revision": "9f799cc8aabdbed2b7825f063c11473a"
  },
  {
    "url": "resources/dia_sr.txt",
    "revision": "eb67acc31921466aae9224e60295b553"
  },
  {
    "url": "resources/dia_sv.txt",
    "revision": "57bbb02cc91273a3553a3580bf1b5fca"
  },
  {
    "url": "resources/dia_sw.txt",
    "revision": "6f638a9850d0163f9b33a2a1b859f205"
  },
  {
    "url": "resources/dia_ta.txt",
    "revision": "a433a519c46cbb7a10d5744e266b8d10"
  },
  {
    "url": "resources/dia_te.txt",
    "revision": "6a972d141c914ada62a2118a6c98b740"
  },
  {
    "url": "resources/dia_th.txt",
    "revision": "2f9b64579b36d7abce17dc96fdb72178"
  },
  {
    "url": "resources/dia_tr.txt",
    "revision": "38f872592b8084844df3bc3bcc7ba324"
  },
  {
    "url": "resources/dia_uk.txt",
    "revision": "be5fc2d538235e59009ad87f80a94411"
  },
  {
    "url": "resources/dia_vi.txt",
    "revision": "0b11feb0b4d3b22463622b695fe669a7"
  },
  {
    "url": "resources/dia_zh-tw.txt",
    "revision": "94f355c4177292f79caedbf76fdf2f22"
  },
  {
    "url": "resources/dia_zh.txt",
    "revision": "ce937c1fede28d377d93bcb3c964130d"
  },
  {
    "url": "favicon.ico",
    "revision": "fab2d88b37c72d83607527573de45281"
  },
  {
    "url": "images/manifest.json",
    "revision": "c6236bde53ed79aaaec60a1aca8ee2ef"
  },
  {
    "url": "images/logo.png",
    "revision": "89630b64b911ebe0daa3dfe442087cfa"
  },
  {
    "url": "images/drawlogo.svg",
    "revision": "4bf4d14ebcf072d8bd4c5a1c89e88fc6"
  },
  {
    "url": "images/drawlogo48.png",
    "revision": "8b13428373aca67b895364d025f42417"
  },
  {
    "url": "images/drawlogo-gray.svg",
    "revision": "0aabacbc0873816e1e09e4736ae44c7d"
  },
  {
    "url": "images/drawlogo-text-bottom.svg",
    "revision": "f6c438823ab31f290940bd4feb8dd9c2"
  },
  {
    "url": "images/default-user.jpg",
    "revision": "2c399696a87c8921f12d2f9e1990cc6e"
  },
  {
    "url": "images/logo-flat-small.png",
    "revision": "4b178e59ff499d6dd1894fc498b59877"
  },
  {
    "url": "images/apple-touch-icon.png",
    "revision": "73da7989a23ce9a4be565ec65658a239"
  },
  {
    "url": "images/favicon-16x16.png",
    "revision": "1a79d5461a5d2bf21f6652e0ac20d6e5"
  },
  {
    "url": "images/favicon-32x32.png",
    "revision": "e3b92da2febe70bad5372f6f3474b034"
  },
  {
    "url": "images/android-chrome-196x196.png",
    "revision": "38b32aefe5d1456144ae00d2c67aab46"
  },
  {
    "url": "images/android-chrome-512x512.png",
    "revision": "959b5fac2453963ff6d60fb85e4b73fd"
  },
  {
    "url": "images/delete.png",
    "revision": "5f2350f2fd20f1a229637aed32ed8f29"
  },
  {
    "url": "images/droptarget.png",
    "revision": "bbf7f563fb6784de1ce96f329519b043"
  },
  {
    "url": "images/help.png",
    "revision": "9266c6c3915bd33c243d80037d37bf61"
  },
  {
    "url": "images/download.png",
    "revision": "35418dd7bd48d87502c71b578cc6c37f"
  },
  {
    "url": "images/logo-flat.png",
    "revision": "038070ab43aee6e54a791211859fc67b"
  },
  {
    "url": "images/google-drive-logo.svg",
    "revision": "5d9f2f5bbc7dcc252730a0072bb23059"
  },
  {
    "url": "images/onedrive-logo.svg",
    "revision": "3645b344ec0634c1290dd58d7dc87b97"
  },
  {
    "url": "images/dropbox-logo.svg",
    "revision": "e6be408c77cf9c82d41ac64fa854280a"
  },
  {
    "url": "images/github-logo.svg",
    "revision": "a1a999b69a275eac0cb918360ac05ae1"
  },
  {
    "url": "images/gitlab-logo.svg",
    "revision": "0faea8c818899e58533e153c44b10517"
  },
  {
    "url": "images/trello-logo.svg",
    "revision": "006fd0d7d70d7e95dc691674cb12e044"
  },
  {
    "url": "images/osa_drive-harddisk.png",
    "revision": "b954e1ae772087c5b4c6ae797e1f9649"
  },
  {
    "url": "images/osa_database.png",
    "revision": "c350d9d9b95f37b6cfe798b40ede5fb0"
  },
  {
    "url": "images/google-drive-logo-white.svg",
    "revision": "f329d8b1be7778515a85b93fc35d9f26"
  },
  {
    "url": "images/dropbox-logo-white.svg",
    "revision": "4ea8299ac3bc31a16f199ee3aec223bf"
  },
  {
    "url": "images/onedrive-logo-white.svg",
    "revision": "b3602fa0fc947009cff3f33a581cff4d"
  },
  {
    "url": "images/github-logo-white.svg",
    "revision": "537b1127b3ca0f95b45782d1304fb77a"
  },
  {
    "url": "images/gitlab-logo-white.svg",
    "revision": "5fede9ac2f394c716b8c23e3fddc3910"
  },
  {
    "url": "images/trello-logo-white-orange.svg",
    "revision": "e2a0a52ba3766682f138138d10a75eb5"
  },
  {
    "url": "images/logo-confluence.png",
    "revision": "ed1e55d44ae5eba8f999aba2c93e8331"
  },
  {
    "url": "images/logo-jira.png",
    "revision": "f8d460555a0d1f87cfd901e940666629"
  },
  {
    "url": "images/clear.gif",
    "revision": "db13c778e4382e0b55258d0f811d5d70"
  },
  {
    "url": "images/spin.gif",
    "revision": "487cbb40b9ced439aa1ad914e816d773"
  },
  {
    "url": "images/checkmark.gif",
    "revision": "ba764ce62f2bf952df5bbc2bb4d381c5"
  },
  {
    "url": "images/hs.png",
    "revision": "fefa1a03d92ebad25c88dca94a0b63db"
  },
  {
    "url": "images/aui-wait.gif",
    "revision": "5a474bcbd8d2f2826f03d10ea44bf60e"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "b5b7280ec98671bb6c3847a36bc7ea12"
  },
  {
    "url": "mxgraph/images/expanded.gif",
    "revision": "2b67c2c035af1e9a5cc814f0d22074cf"
  },
  {
    "url": "mxgraph/images/collapsed.gif",
    "revision": "73cc826da002a3d740ca4ce6ec5c1f4a"
  },
  {
    "url": "mxgraph/images/maximize.gif",
    "revision": "5cd13d6925493ab51e876694cc1c2ec2"
  },
  {
    "url": "mxgraph/images/minimize.gif",
    "revision": "8957741b9b0f86af9438775f2aadbb54"
  },
  {
    "url": "mxgraph/images/close.gif",
    "revision": "8b84669812ac7382984fca35de8da48b"
  },
  {
    "url": "mxgraph/images/resize.gif",
    "revision": "a6477612b3567a34033f9cac6184eed3"
  },
  {
    "url": "mxgraph/images/separator.gif",
    "revision": "7819742ff106c97da7a801c2372bbbe5"
  },
  {
    "url": "mxgraph/images/window.gif",
    "revision": "fd9a21dd4181f98052a202a0a01f18ab"
  },
  {
    "url": "mxgraph/images/window-title.gif",
    "revision": "3fb1d6c43246cdf991a11dfe826dfe99"
  },
  {
    "url": "mxgraph/images/button.gif",
    "revision": "00759bdc3ad218fa739f584369541809"
  },
  {
    "url": "mxgraph/images/point.gif",
    "revision": "83a43717b284902442620f61bc4e9fa6"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








